var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayResponsiblyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.586 2a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707v9.172a1 1 0 01-.293.707l-4.414 4.414a1 1 0 01-.707.293H7.414a1 1 0 01-.707-.293l-4.414-4.414A1 1 0 012 16.586V7.414a1 1 0 01.293-.707l4.414-4.414A1 1 0 017.414 2h9.172zM11.5 5.25a.714.714 0 00-.714.714v4.857a.358.358 0 01-.715 0V7.393a.675.675 0 00-.714-.714.675.675 0 00-.713.714v6.57l-1.43-1.57a.993.993 0 00-.714-.357.976.976 0 00-1 1c-.006.233.07.46.215.643L7.5 15.82s1.785 2.286 4.214 2.286c0 0 4.786.214 4.786-4.143L16.5 8.107a.714.714 0 10-1.429 0v2.714a.357.357 0 11-.714 0V6.68a.715.715 0 10-1.428 0v4.142a.358.358 0 01-.714 0V5.964a.715.715 0 00-.715-.714z",
    fill: "currentColor"
  })));
}
SvgPlayResponsiblyFilled.displayName = 'PlayResponsiblyFilled';
export default SvgPlayResponsiblyFilled;